import * as React from 'react';
import { connect } from 'react-redux';

import { IPosterImage, IDocument } from '../../infrastructure/interfaces';
import PosterImageBackgroundEditorForm from '../DocumentEditor/PosterImageBackgroundEditorForm';
import {
  changePosterImageBackground,
} from '../../actions/actions';

export interface IPosterImagessChoosingProps {
  document: IDocument;
  posterImagesList: IPosterImage[];
  changePosterImageBackground(image: IPosterImage): void;
}

export interface IPosterImagessChoosingState { }

const mapDispatchToProps = (dispatch: any): any => {
  return {
    changePosterImageBackground: (image: IPosterImage): void => {
      dispatch(changePosterImageBackground(image));
    },
  };
};

const mapStateToProps = (state: any): any => {
  return {
    document: state.document,
    posterImagesList: state.wizard.posterImages,
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class PosterImagessChoosing extends React.Component<any, any> {
  render() {
    return (
      <div>
        <div className="stepHeader">
          <div className="stepMessage">
            Choose the poster background image:
          </div>
          <div className="stepMessage2">
            You can change this selection later
        </div>
        </div>
        <PosterImageBackgroundEditorForm
          className="stepContent settingsCropsListContainer settingsCropsListContainer--crops"
          document={this.props.document}
          posterImagesList={this.props.posterImagesList}
          onPosterImageChangeBackground={this.props.changePosterImageBackground}
        />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Steps/PosterImageBackgroundChoosing.tsx